/**
 * aiLauncherGate — the single predicate + WHY-copy behind every AI task
 * launcher entry's disabled state: Object Explorer's "AI" submenu items
 * (`aiSubmenuBuilder.ts`), Schema Overview's "AI: Document this schema"
 * button (`SchemaOverviewTab.tsx`), and any T13 entry that follows.
 *
 * Pulled out in T12 fix round 1 — the predicate was hand-duplicated at 3 JSX
 * sites in `SchemaOverviewTab.tsx` and again inside each context-menu
 * service's own `createAiSubmenu`. One export, one test, reused everywhere.
 */

/** Repo convention (feedback_vqe_disabled_buttons_need_tooltip) — the WHY copy for a disabled AI launcher entry. */
export const AI_CLI_REQUIRED_REASON = 'Install Claude Code or Codex to use AI tasks';

/**
 * False/undefined `aiCliDetectionLoading` + `aiCliAvailable === false` is the
 * only "really disabled" state — everything else (still loading, or a CLI is
 * available) renders enabled. Keeping detection-in-flight enabled avoids a
 * disabled → enabled flicker once the async check resolves.
 */
export function isAiLauncherDisabled(
  aiCliAvailable?: boolean,
  aiCliDetectionLoading?: boolean,
): boolean {
  return aiCliAvailable === false && !aiCliDetectionLoading;
}
